import Meta from '@src/components/Meta';
import Aside from '@src/components/Organism/Aside/Index';
import NoticeTemplate from '@src/components/Template/Notice';
import { metaInfo } from '@src/data/meta';
import PageTemplate from '@src/components/Template/Page';
import { devices } from '@src/styles/theme';
import React from 'react';
import styled from 'styled-components';

const index = () => {
  const { title, description, ogImage } = metaInfo.notice;
  return (
    <PageTemplate
      AsideIsListPage={true}
      AsideDisabledBody={false}
      AsideDisabledTop={true}
      href={'/notice'}
      mainText={'공지사항'}
    >
      <Meta title={title} description={description} ogImage={ogImage} />
      <NoticeTemplate />
    </PageTemplate>
  );
};
const Container = styled.div`
  display: flex;
  max-width: 60%;
  width: 100%;
  justify-content: center;
  margin: 0 auto;
  height: 100%;
  gap: 35px;
  @media ${devices.tablet} {
    max-width: 100%;
  }
`;

const ContentWrap = styled.div`
  flex: 2;
`;
export default index;
